module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white-f78649d5c7c0e70c96406e0c41a06682.png";